var _defs, _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "library",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 41.001,
    height: 28.102,
    viewBox: "0 0 41.001 28.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b23a9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79266a"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6011",
    "data-name": "Rectangle 6011",
    width: 36.009,
    height: 15.1,
    transform: "translate(3.072 6.396)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_57579",
    "data-name": "Path 57579",
    d: "M0,25.547a2.643,2.643,0,0,0,.053.516A2.56,2.56,0,0,0,2.559,28.1H38.442A2.558,2.558,0,0,0,41,25.547V2.555A2.558,2.558,0,0,0,38.442,0h-12.8a5.114,5.114,0,0,0-5.119,5.109A5.114,5.114,0,0,0,15.408,0H2.559A2.555,2.555,0,0,0,.053,3.071V25.03A2.665,2.665,0,0,0,0,25.547ZM28.2,7.664h5.119a2.555,2.555,0,1,1,0,5.109H28.2a2.555,2.555,0,1,1,0-5.109Zm0,7.664h5.119a2.555,2.555,0,1,1,0,5.109H28.2a2.555,2.555,0,1,1,0-5.109ZM7.73,7.664h5.119a2.555,2.555,0,1,1,0,5.109H7.73a2.555,2.555,0,1,1,0-5.109Zm0,7.664h5.119a2.555,2.555,0,1,1,0,5.109H7.73a2.555,2.555,0,1,1,0-5.109Z",
    fill: "#869b34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57580",
    "data-name": "Path 57580",
    d: "M22.951,1.907A5.12,5.12,0,0,1,26.94,0h12.8a2.563,2.563,0,0,1,.909.167,45.227,45.227,0,0,1-4.788,15.481,2.563,2.563,0,0,0-1.24-.32H29.5a2.555,2.555,0,1,0,0,5.109h3.783c-1.6,2.744-3.319,5.333-5.01,7.664H3.854A2.56,2.56,0,0,1,1.4,26.281a43.973,43.973,0,0,0,8.731-5.843h4.01a2.554,2.554,0,0,0,.888-4.951A46.277,46.277,0,0,0,21.8,4.68q.018.213.018.429a5.093,5.093,0,0,1,.028-.531Q22.453,3.231,22.951,1.907ZM34.618,7.664H29.5a2.555,2.555,0,1,0,0,5.109h5.119a2.555,2.555,0,1,0,0-5.109Z",
    transform: "translate(-1.295)",
    fill: "#abc73e",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57581",
    "data-name": "Path 57581",
    d: "M200.262,28.1h23.065a2.558,2.558,0,0,0,2.559-2.555V2.555A2.558,2.558,0,0,0,223.327,0h-2.555a48.09,48.09,0,0,1-2.645,7.664h.081a2.555,2.555,0,1,1,0,5.109h-2.718q-.765,1.284-1.638,2.555h4.356a2.555,2.555,0,1,1,0,5.109H213.09a2.56,2.56,0,0,1-2.207-1.261A43.4,43.4,0,0,1,200.262,28.1Z",
    transform: "translate(-184.886)",
    fill: "#c7e64b",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_57582",
    "data-name": "Path 57582",
    d: "M258.92,87.387V68.96a.96.96,0,1,0-1.92,0V87.387a.96.96,0,0,0,1.92,0Z",
    transform: "translate(-237.267 -62.779)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.317c71159931fcfe4ad11062955178eb.svg";
export { ForwardRef as ReactComponent };